import CurrencySwitcher from './currency_switcher';

export default class PriceInput {
	constructor(container) {
		this.price_input = container.querySelector('input:not([type="hidden"])');
		this.local_currency_switcher =
			container.querySelector('.currency_switcher');
		this.local_currency_switcher_button =
			this.local_currency_switcher.querySelector(':scope > button');
		this.data = this.price_input.dataset;

		this.local_currency_switcher_button.addEventListener(
			'change', () => {
				this._set_min();
				this.calculate_hint();
			}
		);
		this.price_input.addEventListener(
			'invalid', () => this._set_validity()
		);
		this._set_min();

		this.hint = document.querySelector('.price_input ~ .price-hint');
		this.price_hint_commission =
			this.hint.querySelector('.price-hint__commission').dataset.commission;

		this.price_input
			.addEventListener('input', event => this.calculate_hint());

		this.price_input.dispatchEvent(new Event('input'));
	}

	_currency() {
		return this.local_currency_switcher.querySelector(
			`
				:scope >
					.dropdown >
					ul[data-main="true"] >
					li[data-value="${this.local_currency_switcher_button.value}"]
			`
		).dataset.code;
	}

	_set_min() {
		this.price_input.min =
			this._currency() === 'RUB' ? this.data.rubMin : this.data.min;
		this.data.rangeUnderflowError =
			this.data.rangeUnderflowError.replace(
				/(%{value}|\d+)/,
				this.price_input.min
			);
		this._set_validity();
	}

	_set_validity() {
		if (this.price_input.validity.rangeUnderflow) {
			this.price_input.setCustomValidity(
				this.data.rangeUnderflowError
			);
		} else {
			this.price_input.setCustomValidity('');
		}
	}

	_format(value) {
		return CurrencySwitcher.format(value, this._currency());
	}

	calculate_hint() {
		this.hint.querySelector('.price-hint__earning').innerHTML = this._format(
			parseFloat(this.price_input.value) * (1 - this.price_hint_commission)
		);
		this.hint.querySelector('.price-hint__commission').innerHTML = this._format(
			parseFloat(this.price_input.value) * this.price_hint_commission
		);
		this.hint.classList.toggle('open', this.price_input.value > 0);
	}
}
